<lib-hours-display [personId]="personId" [employeeHomepageHeader]="true"></lib-hours-display>
<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-4">
        <div class="btn-group">
          <button
            class="btn btn-tertiary"
            mwlCalendarPreviousView
            view="month"
            [(viewDate)]="viewDate">
            <i class="fas fa-chevron-left"></i> Previous
          </button>
          <button
            class="btn btn-secondary"
            [disabled]="isDateInMonth"
            mwlCalendarToday
            [(viewDate)]="viewDate">
            Today
          </button>
          <button class="btn btn-tertiary" mwlCalendarNextView view="month" [(viewDate)]="viewDate">
            Next <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
      <div class="col-4 text-center">
        <h3>{{ viewDate | calendarDate: 'monthViewTitle' : 'en' }}</h3>
      </div>
      <div class="col-4 text-end">
        <button class="btn btn-primary" (click)="openNewRequestModal()">
          <i class="fas fa-plus"></i> Add Time Off
        </button>
      </div>
    </div>
    <div class="grid mb-2 mt-2">
      <lib-multiselect
        [options]="statusFilter"
        [ngModel]="currentFilters | async"
        (ngModelChange)="statusFilterChange($event)"></lib-multiselect>
      <div
        class="d-flex flex-column justify-content-center"
        *ngFor="let filter of currentFilters | async">
        <div>
          <button
            (click)="filterPillClicked(filter)"
            class="badge rounded-pill border-1 border pill-border bg-white">
            {{ filter }} <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
      <div
        class="d-flex flex-column justify-content-center"
        *ngIf="(currentFilters | async).length > 0">
        <button (click)="clearFiltersClicked()" class="btn btn-link">Clear All</button>
      </div>
    </div>
    <mwl-calendar-month-view
      [viewDate]="viewDate"
      [events]="events | async"
      [refresh]="refresh"
      [activeDayIsOpen]="activeDayIsOpen"
      (dayClicked)="dayClicked($event.day)"
      (eventClicked)="eventClicked($event.event)"
      [cellTemplate]="cellTemplate">
    </mwl-calendar-month-view>

    <ng-template
      #cellTemplate
      #defaultTemplate
      let-day="day"
      let-openDay="openDay"
      let-locale="locale"
      let-tooltipPlacement="tooltipPlacement"
      let-highlightDay="highlightDay"
      let-unhighlightDay="unhighlightDay"
      let-eventClicked="eventClicked"
      let-tooltipTemplate="tooltipTemplate"
      let-tooltipAppendToBody="tooltipAppendToBody"
      let-tooltipDelay="tooltipDelay"
      let-trackByEventId="trackByEventId"
      let-validateDrag="validateDrag">
      <div
        [class.isPast]="day.isPast"
        class="cal-cell-top"
        [attr.aria-label]="{ day: day, locale: locale } | calendarA11y: 'monthCell'">
        <span aria-hidden="true">
          <span class="cal-day-number">{{
            day.date | calendarDate: 'monthViewDayNumber' : locale
          }}</span>
        </span>
      </div>
      <div
        class="d-flex flex-column justify-content-start m-0"
        [class.isPast]="day.isPast"
        style="align-items: start"
        *ngIf="day.events.length > 0">
        <ng-container *ngFor="let event of day.events; trackBy: trackByEventId">
          <div
            class="w-100 p-1 mb-1"
            [class.pendingChangeBackground]="event.meta.EditedByApprover"
            [class.pendingChangeTextBackground]="event.meta.Pending || event.meta.EditedByRequester"
            [class.bg-connectpay]="event.meta.Approved && !event.meta.EditedByApprover"
            [class.bg-danger]="event.meta.Declined"
            [class.startBorder]="AreDatesEqual(day.date, event.start)"
            [class.endBorder]="AreDatesEqual(day.date, event.end) || event.end == null"
            (mwlClick)="eventClicked.emit({ event: event, sourceEvent: $event })">
            <small class="fw-bold" [class.text-white]="!event.meta.EditedByApprover">
              {{ event.title | calendarEventTitle: 'monthTooltip' : event }}
            </small>
          </div>
        </ng-container>
      </div>
    </ng-template>
  </div>
</div>

<ng-template #newRequestModal let-nrModal>
  <lib-employee-time-off-request-modal
    *ngIf="showNewRequestModal"
    [defaultDay]="defaultDay"
    [existingModel]="currentRequest"
    [personId]="personId"
    (modalClosed)="closeNewRequestModal()"></lib-employee-time-off-request-modal>
</ng-template>
<ng-template #approveRequestModal let-arModal>
  <lib-employee-conditional-approval
    *ngIf="showApproveRequestModal"
    [editedRequests]="editedRequests | async"
    [personId]="personId"
    [openRequests]="openRequests | async"
    [existingModel]="currentRequest"
    [clientCode]="clientCode"
    (modalClosed)="closeNewRequestModal()"></lib-employee-conditional-approval>
</ng-template>

<ng-template #approvedRequestModal>
  <lib-employee-approved-request-modal
    *ngIf="showApprovedRequestModal"
    [editedRequests]="editedRequests | async"
    [personId]="personId"
    [openRequests]="openRequests | async"
    [existingModel]="currentApprovedRequest"
    [clientCode]="clientCode"
    (modalClosed)="closeNewRequestModal()"></lib-employee-approved-request-modal>
</ng-template>
<ng-template #editedRequestModal>
  <lib-employee-request-edited
    *ngIf="showEditedRequestModal"
    [editedRequests]="editedRequests | async"
    [openRequests]="openRequests | async"
    [existingModel]="currentEditedRequest"
    [clientCode]="clientCode"
    (modalClosed)="closeNewRequestModal()"></lib-employee-request-edited>
</ng-template>
